<template>
    <div class="uk-self-categorisation-modal">
        <img src="@webapp/assets/statuses/denied.webp"
            class="uk-self-categorisation-modal__image"
            alt="Modal icon"
        >
        <div class="uk-self-categorisation-modal__wrapper">
            <translation-string :translation="$t('jurisdictionRequirements.ukSelfCategorisation.deniedModalMessage')"
                class="uk-self-categorisation-modal__text"
            />
        </div>

        <div class="uk-self-categorisation-modal__actions">
            <button class="button"
                @click="closeModal"
            >
                {{ $t('global.button.close') }}
            </button>
        </div>
    </div>
</template>

<script>
import {
    mapActions,
} from 'vuex';

// Components
import translationString from '@webapp/components/translation-string.vue';

// Local Modules
import localStoreTypes from '@webapp/store/types.js';

export default {
    name: 'uk-self-categorisation-modal',
    components: {
        translationString,
    },
    methods: {
        ...mapActions({
            resetModal: localStoreTypes.RESET_MODAL,
        }),

        closeModal() {
            if (this.$route.fullPath !== '/home/overview') {
                this.$router.push('/home/overview');
            }
            this.resetModal();
        },
    },
};
</script>

<style lang="scss" scoped>
.uk-self-categorisation-modal {
    &__wrapper {
        padding-top: 2.6rem;
        background: $white-color;
        text-align: center;
        color: $cyprus-color;
        font-size: 1.5rem;
        line-height: 2rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;

        @include max-width(sm) {
            padding: 2rem 0;
        }
    }

    &__image {
        display: block;
        margin: 0 auto;
        object-fit: contain;
        max-width: 13.6rem;
        min-height: 12rem;

        @include min-width(md) {
            max-width: 15.6rem;
            min-height: 16rem;
        }

        @include max-width(sm) {
            max-width: 9.6rem;
            min-height: 11rem;
        }
    }

    &__title {
        font-size: 1.6rem;
        font-weight: bold;
    }

    &__text {
        font-size: 1.4rem;
        text-align: center;
        color: $cyprus-color;
    }

    &__actions {
        padding: 1rem 0;
        display: block;
        width: 100%;
        margin-top: 2rem;

        .button {
            display: block;
            margin: 0 auto 1rem;
            height: 3.5rem;
            line-height: 3.5rem;
            width: 20rem;
            border-radius: 0.5rem;
            background: $lima-color;
            text-align: center;
            font-size: 1.4rem;
            color: $daintree-color;
            border: none;
            align-self: flex-end;

            @include min-width(md) {
                width: 21.9rem;
            }

            &:hover {
                cursor: pointer;
                opacity: 0.8;
            }
        }
    }
}
</style>